import { createCustomerOrgUnitScope } from '@/helpers/queryKeyScopes'

const scope = createCustomerOrgUnitScope('getAllFavoriteListIdsByProduct')

export const getAllFavoriteListIdsByProductKeys = {
  ...scope,
  product: (customerId: string, orgUnitId: string, productId: string) => {
    return [...scope.orgUnit(customerId, orgUnitId), 'product', productId] as const
  },
} as const
